'use strict';
const strings = require('./string');
const uuid = require('uuid/v4');
const errorHandler = require('./error-handler');

class RequestConfigurationManager {
  constructor(sdkConfiguration, request, credentials) {
    this.sdkConfiguration = sdkConfiguration;
    this.credentials = credentials;
    this.request = request;
    this.resolveWithFullResponse = false;
  }

  setApi(api) {
    if (!this.sdkConfiguration.Apis[api]) {
      throw errorHandler.handleError('The api does not exists');
    }
    this.setPath(api);
    this.setMethod(api);
    this.setAuthorization(api);
    this.setDefaultHeaders();
    return this;
  }

  getAuthorization() {
    if (this.Authorization) {
      return this.Authorization;
    }
    throw errorHandler.handleError('Authorization param is not set');
  }

  setAuthorization(api) {
    if (typeof this.sdkConfiguration.Apis[api].Authorization === 'boolean') {
      this.Authorization = this.sdkConfiguration.Apis[api].Authorization;
      return this;
    }
    throw errorHandler.handleError('Authorization must be a boolean');
  }

  getMethod() {
    if (this.Method) {
      return this.Method;
    }
    throw errorHandler.handleError('Method param is not set');
  }

  setMethod(api) {
    if (this.sdkConfiguration.Apis[api].Method && (this.sdkConfiguration.Apis[api].Method === 'PUT' || this.sdkConfiguration.Apis[api].Method === 'POST'
      || this.sdkConfiguration.Apis[api].Method === 'DELETE' || this.sdkConfiguration.Apis[api].Method === 'GET'
      || this.sdkConfiguration.Apis[api].Method === 'PATCH')) {
      this.Method = this.sdkConfiguration.Apis[api].Method;
      return this;
    }
    throw errorHandler.handleError('Expected Method in sdkConfiguration');
  }

  getForm() {
    return this.Form;
  }

  setForm(form) {
    if (typeof form === 'object' && form !== null) {
      this.Form = form;
      if (this.Method === 'GET') {
        this.Form = 'not-needed';
      }
      return this;
    }
    throw errorHandler.handleError('Form needs to be an object');
  }

  getPathParams() {
    if (this.PathParams) {
      return this.PathParams;
    }
    throw errorHandler.handleError('PathParams is not set');
  }

  getUri() {
    if (this.Uri) {
      return this.Uri;
    }
    throw errorHandler.handleError('Uri is not set');
  }

  setUri(pathParams) {
    if (!pathParams) {
      this.Uri = this.Path;
      return this;
    }
    if (Array.isArray(pathParams)) {
      this.PathParams = pathParams;
      const uri = strings.format(this.getPath(), pathParams);
      this.Uri = uri;
      return this;
    }
    throw errorHandler.handleError('Expected pathParams, must be an array');
  }

  getPath() {
    if (this.Path) {
      return this.Path;
    }
    throw errorHandler.handleError('Path is not set');
  }

  setPath(api) {
    if (this.sdkConfiguration.Apis[api].Path) {
      this.Path = this.sdkConfiguration.Apis[api].Path;
      return this;
    }
    throw errorHandler.handleError('Expected path in sdkConfiguration');
  }

  setResolveWithFullResponse() {
    if(this.getMethod() === 'DELETE'){
      this.resolveWithFullResponse = true;
    }else{
      this.resolveWithFullResponse = false;
    }
  }

  getRequestOptions() {
    this.setResolveWithFullResponse();

    const options = {
      method: this.getMethod(),
      uri: this.getUri(),
      form: this.getForm(),
      body: this.getBody(),
      headers: this.getHeaders(),
      json: true,
      resolveWithFullResponse: this.resolveWithFullResponse,
    };
    return options;
  }

  getOptions(options) {
    if (typeof options === 'object') {
      this.setUri(options.pathParams);
      if (options.form) {
        this.setForm(options.form);
      }
      if (options.queryParams) {
        this.setQuery(options.queryParams);
      }
      if (options.bodyParams) {
        this.setBody(options.bodyParams);
      }
      if (options.headerParams) {
        Object.assign(this.Headers, options.headerParams);
      }
      return this.getRequestOptions();
    }
    throw errorHandler.handleError('Options must be an object');
  }

  getBody() {
    return this.Body;
  }

  setBody(bodyParams) {
    if (typeof bodyParams === 'object') {
      this.Body = bodyParams;
      return this;
    }
    throw errorHandler.handleError('Expected bodyParams to be an object');
  }

  setAuthorizationHeader(accessToken) {
    if (this.Authorization) {
      this.Headers.Authorization = 'Bearer ' + accessToken;
    }
    return this;
  }

  getHeaders() {
    if (this.Headers) {
      return this.Headers;
    }
    throw errorHandler.handleError('Header is not set');
  }

  addHeader(header, value) {
    this.Headers[header] = value;
    return this;
  }

  setDefaultHeaders() {
    this.Headers = {
      Accept: 'application/json',
      'MS-RequestId': uuid(),
      'MS-CorrelationId': uuid(),
      'Content-Type': 'application/json',
    };
    return this;
  }

  setQuery(queryParams) {
    if (Array.isArray(queryParams)) {
      for (let index = 0; index < queryParams.length; index++) {
        if (typeof queryParams[index] === 'object') {
          const name = Object.getOwnPropertyNames(queryParams[index]);
          if (index === 0) {
            this.Uri += '?' + name[0] + '=' + queryParams[index][name[0]];
          } else {
            this.Uri += '&' + name[0] + '=' + queryParams[index][name[0]];
          }
        } else {
          throw errorHandler.handleError('Property inside queryParams must be an object');
        }
      }
      return this;
    }
    throw errorHandler.handleError('Expected queryParams to be an array');
  }

}

module.exports = RequestConfigurationManager;
